import {useState} from "react";

export const StarRating = ({ value, onChange }: { value: number; onChange: (val: number) => void }) => {
    const [hover, setHover] = useState(0);

    return (
        <div style={{ display: 'flex', gap: 4, cursor: 'pointer' }}>
            {[1, 2, 3, 4, 5].map(star => (
                <span
                    key={star}
                    style={{
                        fontSize: '1.8rem',
                        color: star <= (hover || value) ? '#78218a' : '#444',
                        transition: 'color 0.15s'
                    }}
                    onClick={() => onChange(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(0)}
                >
                    ★
                </span>
            ))}
        </div>
    );
};

export default StarRating;
